import { CandidateData } from '@/network/definitions/job';
// import { useGet } from "@hooks/apiHooks.ts";
// import { Button } from 'baseui/button';

export interface VetsmithStatusType {
    step: string;
    step_status: string;
    status: string;
}

export interface VetsmithStatusResponse {
    developerId: number;
    flowId: number;
    status: VetsmithStatusType[];
    vetsmithStatus: string;
}

export const VetsmithText = ({
    item
}: { item: CandidateData }) => {
    if (!item.vetsmith) return '-'
    // const {
    //     data,
    //     // refetch, 
    //     // isFetching 
    // } = useGet<VetsmithStatusResponse>(`agency-api/job/${item.job_id}/developer/${item.developer_id}/vetsmith-status/${item.vetsmith?.flowId || null}`, {}, false);
    const vetsmithDetails = item.vetsmith;
    const getVetsmithStatus = () => {
        if (vetsmithDetails && !item.is_duplicated) {
            return vetsmithDetails.displayText;
        } else {
            return '-';
        }
    }

    return <span>
        {getVetsmithStatus()}
        {/* {data === undefined && item.vetsmith.displayText !== '-' &&
            <Button
                isLoading={isFetching}
                onClick={() => refetch()}
                kind="tertiary"
                overrides={{
                    BaseButton: {
                        style: {
                            backgroundColor: 'transparent',
                            color: '#000',
                            padding: '0',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: 'none',
                            border: 'none',
                            marginLeft: '4px'
                        },
                    },
                }}
            >Details</Button>}
        <ul>
            {data && (data.data as VetsmithStatusResponse).status.map(stat => (
                <li>{stat.step}: {stat.status}</li>
            ))}
        </ul> */}
    </span>
}